"use strict";
import { useEffect, useContext, useState } from "react";
// @mui material components
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  ToggleButton,
  ToggleButtonGroup,
  Grid,
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
// import Grid from '@mui/material/Grid'
import { Link as MuiLink, Stack, Tooltip } from "@mui/material";
import ReportIcon from '@mui/icons-material/Report';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
// import MDTypography from 'components/MDTypography'
import MDSnackbar from "components/MDSnackbar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
// import MDDropdown from 'components/MDDropdown'

// Material Dashboard 2 PRO React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import DataTable from "components/Tables/DataTable";

// zerouno
import authService from "services/auth.service";
import customerService from "services/customer.service";
import troubleticketService from "services/troubleticket.service";
import userService from "services/user.service";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import ZUTitleForm from "components/ZeroUno/ZUTitleForm";
import utils from "utils/utils.js";
import RabbitContext from "context/rabbit.js";
import { config } from "variables/Config.js";
import MDTypography from "components/MDTypography";
import { DateTime } from "luxon";

export default function TroubleticketTable() {
  const location = useLocation();
  const { rabbit } = useContext(RabbitContext);

  const [objId, setObjId] = useState(0);
  const { idCustomer } = useParams();
  const { idOrder } = useParams();

  const [obj, setObj] = useState([]);
  const [objects, setObjects] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [aperti, setAperti] = useState(true);
  
  const [showSnackbar, setShowSnackbar] = useState({
    sh: false,
    msg: "",
    color: "success",
  });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetchObjects();
  }, []);
  
  useEffect(() => {
    setFiltered(objects.filter(obj => aperti ? !obj.chiuso : true));  
  }, [objects, aperti]);

  const fetchObjects = () => {
    if (idCustomer) {
      troubleticketService.getByCustomer(rabbit.companyId, idCustomer)
        .then((response) => {
          setObjects(response.data);
        })
        .catch((error) => {
          setShowSnackbar({
            sh: true,
            msg: error.response
              ? error.response.data.message
              : "errore di ricezione dati",
            color: "error",
          });
        });
    }
    else if (idOrder) {
      troubleticketService.getByOrder(rabbit.companyId, idOrder)
        .then((response) => {
          setObjects(response.data);
        })
        .catch((error) => {
          setShowSnackbar({
            sh: true,
            msg: error.response
              ? error.response.data.message
              : "errore di ricezione dati",
            color: "error",
          });
        });
    } else {
      troubleticketService.getAll(rabbit.companyId)
        .then((response) => {
          setObjects(response.data);
          console.log(response.data)
        })
        .catch((error) => {
          setShowSnackbar({
            sh: true,
            msg: error.response
              ? error.response.data.message
              : "errore di ricezione dati",
            color: "error",
          });
        });
    }
  };

  const columns = [
    {
      Header: "azioni",
      sortable: false,
      filterable: false,
      width: 100,
      accessor: (row) => (
            <MDButton
              color="info"
              size="small"
              iconOnly
              component={Link}
              to={`/troubletickets/${row.id}`}
              sx={{ mr: 1 }}
            >
              <Icon>edit</Icon>
            </MDButton>
      ),
    },
    {
      Header: 'new',
      accessor: (d) => {
        if (d.ttusers?.length === 0) {
          return (
            <Tooltip title='non letto'>
              <Icon fontSize='large' color='info'>new_releases</Icon>
            </Tooltip>
          )
        }
      }
    },
    {
      Header: "cliente",
      accessor: (row) =>
        row.customer.surname.toUpperCase() +
        " " +
        row.customer.name.toUpperCase(),
    },
    {
      Header: "ordine",
      accessor: (row) =>
        row.order? row.order.number + row.order.extension ? " [ext]" : "" + row.order.substitution ? " [sost]" : "" : "",
    },
    {
      Header: "oggetto",
      accessor: (row) =>
        row.oggetto,
    },
    {
      Header: "stato",
      accessor: (row) =>
        row.chiuso ? "chiuso" : "aperto",
    },
    {
      Header: "data",
      accessor: (d) => {
        return utils.formatDate(d.data, "dd/MM/yyyy");
      },
    },
    {
      Header: "utente",
      accessor: (row) => row.user.username,
    },
  ];

  const urlNew = () => {
    if (idCustomer && !idOrder) {
      return `/customers/${idCustomer}/troubletickets/new`;
    } else if (idCustomer && idOrder) {
      return `/customers/${idCustomer}/orders/${idOrder}/troubletickets/new`;
    } else {
      return `/troubletickets/new`;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm
            bgColor="info"
            title="Trouble Tickets"
            icon="list_alt"
          />
          <MDBox p={3} lineHeight={1}>
            <Stack direction="row" justifyContent="start">
              {idCustomer && (
                <MDButton
                  color="secondary"
                  component={Link}
                  to="/customers"
                  sx={{ m: 1 }}
                >
                  clienti
                </MDButton>
              )}
              {idOrder && (
                <MDButton
                  color="secondary"
                  component={Link}
                  to={`/orders`}
                  sx={{ m: 1 }}
                >
                  ordini
                </MDButton>
              )}
              {!idCustomer && !idOrder && (
                <MDButton
                color="secondary"
                component={Link}
                to={`/troubletickets`}
                sx={{ m: 1 }}
              >
                tutti i tickets
              </MDButton>
              )}
                <MDButton
                color="info"
                component={Link}
                to={urlNew()}
                sx={{ m: 1 }}
              >
                nuovo
              </MDButton>
              <MDButton
                color={aperti ? "warning" : "success"}
                onClick={() => setAperti(!aperti)}
                sx={{ m: 1 }}
              >
                {aperti ? "vedi tutti" : "solo aperti"}
              </MDButton>
            </Stack>
          </MDBox>
          <DataTable 
            table={{ columns: columns, rows: filtered }} 
            canSearch 
            pagination={{ 
              variant: "gradient", 
              color: "success",
              currentPage: currentPage,
              onPageChange: (newPage) => setCurrentPage(newPage)
            }}
          />
        </Card>
      </MDBox>
      <Footer />
      
      <MDSnackbar
        color={showSnackbar.color}
        icon="notifications"
        title="Notifica"
        content={showSnackbar.msg}
        dateTime="adesso"
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: "", color: "info" })}
      />
    </DashboardLayout>
  );
}
